import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

/**
 * Route guard for admin pages. Must be nested inside <RequireAuth>.
 * Non-admin users are sent back to their dashboard.
 */
const RequireAdmin: React.FC = () => {
    const user = useAuthStore((state) => state.user);

    // Mirror navConfig's isAdmin() so the guard and sidebar filtering agree.
    const isAdmin = !!user && (user.is_admin === true || user.role === 'admin');

    if (!isAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;
};

export default RequireAdmin;
